import React, { useMemo, useState } from "react";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
    FormTitle,
    FormText,
    Container
} from 'screens/Authentication/Forgot/styled';

import Button from "components/Form/Button";
import Input from 'components/Form/Input';
import ContainerUnauthenticated from "containers/Unauthenticated";
import { DoMVUAcceleratorForgotPassword } from "services/authentication";
import { exposeStrapiError } from "utils";
import { UnauthenticatedContainer } from "ui/styled";
import useI18n from "hooks/useI18n";

export default function MVUAcceleratorForgot() {
    const history = useHistory();
    const navigate = to => history.push(`/${to}`);
    const { t } = useI18n();

    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [form, setForm] = useState({});
    const formValue = ref => (form?.[ref] ? form?.[ref] : '');
    const changeForm = (value, ref) => { setForm({ ...form, [ref]: value }); };

    const valid = (verbose = false) => {
        if (!formValue('email') || !formValue('email').length) {
            if (verbose) toast.error(`${t("fill_the_field")}: ${t("email")}`);
            return false;
        }
        return true;
    };

    const steps = useMemo(() => ([
        { title: t("reset_password"), text: t("enter_your_email_to_recover_your_password"), label: t("send") },
        { title: t("check_your_email"), text: t("access_the_recovery_link_that_was_sent_to_your_email"), label: t("back_to_login") },
    ]), [t]);

    const action = async () => {
        if (!valid(true)) return;
        setLoading(true);
        const result = await DoMVUAcceleratorForgotPassword({ email: formValue('email')?.replace(/ /g, '') });
        setLoading(false);
        if (result && !exposeStrapiError(result)) {
            setActiveStep(activeStep + 1);
        }
    };

    const next = () => {
        if (activeStep + 1 < steps.length) {
            action();
            return;
        }
        navigate("mvu-accelerator/login");
    };

    return (
        <ContainerUnauthenticated portal="accelerator" lightBlue>
            <UnauthenticatedContainer>
                <Container>
                    <FormTitle>{steps?.[activeStep]?.title}?</FormTitle>
                    <FormText>{steps?.[activeStep]?.text}</FormText>
                </Container>
                {activeStep !== 0 ? null : (
                    <Input
                        placeholder={t("email")}
                        id={'email'}
                        value={formValue('email')}
                        onChange={e => changeForm(e.target.value, 'email')}
                    />
                )}
                <Button color="blue" loading={loading} nospace onClick={next}>
                    {steps?.[activeStep]?.label}
                </Button>
            </UnauthenticatedContainer>
        </ContainerUnauthenticated>
    );
}
